<ng-container>
  <div
    id="trenching-map"
    class="map"
    leaflet
    [leafletOptions]="mapOptions"
    (leafletMapReady)="onMapReady($event)"
  ></div>
</ng-container>

@if (mapLoaded) {
  <app-map-controls
    [map]="map"
    [showGeolocation]="showGeolocation"
    [overlay]="overlay"
    [activeSidePanel]="activeSidePanel"
    [version]="this.version()"
    (homeClicked)="centerView()"
    (geolocationClicked)="onGeolocationClicked()"
    (sidePanelSelected)="onSidePanelSelected($event)"
  />
}
